import React, { useEffect, useState } from 'react'
import {  useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { login } from '../../actions/auth'

import { fetchConToken } from '../../helpers/fetch'
import { UserPurchaseScreen } from './UserPurchaseScreen'

export const UserProfileScreen = () => {

    const { auth,sell } = useSelector(state => state)

    const [user, setUser] = useState({})

    const [purchase, setPurchase] = useState([])

const mantenimiento = true
    let compras =[]
    useEffect(() => {
      
      sell.map( resp => {
       if(resp.usuario.id === auth.uid){
        compras.push(resp)
       }
      } )

      
     
      setPurchase(compras)
    }, [sell])


    const dispatch = useDispatch()

    useEffect(() => {
    
     const filterUser = async() =>{


     await  fetchConToken('auth/users').then( resp => resp.json()).then(res => {

         res.users.map(user =>{
          if( user.id === auth.uid){
  
            setUser(user)
          }  
         })
         
        })
      

     } 

     filterUser()

   }, [])

 
// console.log(user)
   
 
  const {id,password,name,steam} = user

  const handleInputChange = ({target}) => {
   
    setUser({
        ...user,
        
        [target.name]: target.value
    })
    }

    const handleSubmitForm = (e) =>{
      e.preventDefault()

      setUser({
          ...user
      })

      fetchConToken(`auth/users/${ id }`,user,'PUT');
     
      dispatch( login({
        ...auth,
        name: user.name,
        steam: user.steam
        })
    );

    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Perfil editado',
      showConfirmButton: false,
      timer: 1500
    })
     
  }

  const handleClean = ({target}) =>{
    setUser({
      ...user,
      
      [target.name]: ""
  })
  }



  return (

    <section className='_profile-Container'>

      {mantenimiento ?
      <div>

        <p>Seccion en Mantenimiento</p>
        
      </div>


    :



        <div className='container  userProfile '>

          <div className='row'>

            <aside className='col-3'> 

              <div className='avatar-container'>
              <img src="https://elchapuzasinformatico.com/wp-content/uploads/2020/11/Counter-Strike-1.0.jpg" alt="" />

              </div>

              <div className='ul-container'>
                <ul className="nav btn-toggle-nav mb-3 col-12 row" id="pills-tab" role="tablist">
                  <li  role="presentation">
                      <div 
                        className=" col-12 active" 
                        id="setting" 
                        href="#setting" 
                        data-bs-toggle="pill" 
                        data-bs-target="#pills-setting" 
                        type="button" 
                        role="tab" 
                        aria-controls="Users" 
                        aria-selected="true"
                      >
                          Datos de Perfil
                      </div>
                  </li>

                  <li role="presentation">
                      <div 
                        className="col-12" 
                        id="compras" 
                        href="#compras" 
                        data-bs-toggle="pill" 
                        data-bs-target="#pills-compras" 
                        type="button" 
                        role="tab" 
                        aria-controls="pills-compras" 
                        aria-selected="false"
                      >
                        Compras
                      </div>
                  </li>

                  
                </ul>
              </div>

        


            </aside>


            <section className='col-9'>

              <div className='tab-content' id="pills-tabContent1">


      {/* PERFIL */}
                <div className="tab-pane fade show active " id="pills-setting" role="tabpanel" aria-labelledby="setting">

                    <form 
                      className="info"
                      onSubmit={ handleSubmitForm }
                    >
                      <div >
                        Email: {user.email} <span className='mt-5'>(No se puede modificar)</span>
                      </div>

                    <div className='row'>
                      <label htmlFor="name" className='col-12'>Nombre de perfil: </label>

                      <input 
                          className='col-9'
                          type="text"           
                          name="name"
                          id='name'
                          autoComplete="off"
                          value={name}
                          onChange={ handleInputChange }
                          required
                      />
                    </div>

                    <div>
                    <label htmlFor="name">Nuevo Password: </label>
                      <input 
                        className=' mt-2'
                          type="password"                
                          name="password"
                          autoComplete="off"
                          value={password}
                         onClick={handleClean}
                          placeholder="Introduzca nuevo password"
                          onChange={ handleInputChange }
                       
                      />
                    </div>

                    <div>
                    <label htmlFor="steam">Perfil de Steam: </label>
                      <input 
                        className=' mt-2'
                          type="text"                
                          name="steam"
                          id='steam'
                          value={steam}
                          onClick={handleClean}
                          autoComplete="off"
                          placeholder=''
                          onChange={ handleInputChange }
                         
                      />
                    </div>



                    <button className='btn_blue mb-2 mt-5 col-3' type="submit"> Editar Todo</button>

                    </form>


                 

                </div>

      {/* COMRPAS */}
                <div className="tab-pane fade" id="pills-compras" role="tabpanel" aria-labelledby="compras">
                    
                  <UserPurchaseScreen purchase={purchase}/>

                </div>

              </div>

            </section>

          </div>
           

        </div>
    }

    </section>
  )
}
